import { applyLandingMetadata } from './landing/landingSeo';
/**
 * Página pública de preços para agentes — /precos-agentes.
 * CTA grátis → registo; CTA Premium → subscrição, com login se necessário.
 */
import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AgentPricingPlans } from '../components/AgentPricingPlans';

export default function AgentPricingPublicPage() {
  useEffect(() => applyLandingMetadata('/precos-agentes', false), []);
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: 'var(--brand-paper, #1A1B2E)', fontFamily: "var(--brand-font-body, 'Poppins', system-ui, sans-serif)" }} data-testid="agent-pricing-public">
      <div style={{ maxWidth: 1180, margin: '0 auto', padding: '0 28px' }}>
        <header style={{ padding: '48px 0 40px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Link to="/" className="brand-name" style={{ fontSize: 22, fontWeight: 700, color: 'var(--brand-ink, #FAFAF7)', textDecoration: 'none', fontFamily: 'var(--brand-font-display, inherit)' }}>
              mi<span style={{ color: 'var(--brand-ink, #A78BD9)' }}>D</span>
            </Link>
            <Link to="/login" data-testid="pricing-login-link"
              style={{ fontSize: 13.5, color: 'var(--brand-muted, rgba(255,255,255,0.55))', textDecoration: 'none' }}>
              Entrar
            </Link>
          </div>
          <div style={{ marginTop: 56 }}>
            <div style={{ fontFamily: "var(--brand-font-mono, 'IBM Plex Mono', monospace)", fontSize: 11.5, letterSpacing: '0.28em', textTransform: 'uppercase', color: 'var(--brand-muted, #3CC8B5)' }}>
              Planos para agentes
            </div>
            <h1 className="agent-heading" style={{ fontSize: 'clamp(2.2rem, 5vw, 3.6rem)', fontWeight: 600, letterSpacing: '-0.045em', lineHeight: 1.05, color: 'var(--brand-ink, #FAFAF7)', marginTop: 18 }}>
              Vê a procura da tua zona.<br /><span style={{ color: 'var(--brand-primary, #A78BD9)' }}>Age sobre ela.</span>
            </h1>
            <p style={{ fontSize: 17, fontWeight: 300, lineHeight: 1.6, color: 'var(--brand-muted, #B9BACB)', marginTop: 20, maxWidth: '42em' }}>
              Compradores com Buyer DNA completo nas tuas zonas de atuação, e o estado do crédito de cada um.
              Ver é gratuito e para sempre. Submeter imóveis é o que distingue o Premium.
            </p>
          </div>
        </header>
        <AgentPricingPlans
          onFreeCta={() => navigate('/register?type=agent')}
          onPremiumCta={(cycle) => navigate('/agent/subscribe?cycle=' + cycle)}
          freeCtaLabel="Criar conta gratuita"
        />
      </div>
    </div>
  );
}
